import HttpRequest from "./HttpRequest";

export default class AssetAuditingService {

  httpRequest = new HttpRequest();

  baseUrl = '/ton/v1/auditing/assets'

  async getAssetAuditingById(assetId) {
    return this.httpRequest.get(`${this.baseUrl}/${assetId}`);
  }
}



// WEBPACK FOOTER //
// ./src/services/AssetAuditingService.js